"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
require("./ContentNavigator.scss");
const ContentNavigator = ({ customClassContainer = '', title = 'CONTENTS', additionalOffset = 0, isIncreaseOffset = false, activeSection = 'template-name', listNavigatorContents = [
    { id: 'template-name', name: 'Template name' },
    { id: 'rating-configuration', name: 'Rating Configuration' }
], sectionContent = '', useId = false }) => {
    const scrollToElement = (id) => {
        const elmnt = document.getElementById(id);
        const content = sectionContent
            ? document.getElementById(sectionContent)
            : elmnt?.offsetParent;
        const offsetTop = elmnt?.offsetTop || 0;
        content?.scroll({
            top: isIncreaseOffset
                ? offsetTop + additionalOffset
                : offsetTop - additionalOffset,
            behavior: 'smooth'
        });
    };
    return (react_1.default.createElement("div", { className: `content-navigator-container ${customClassContainer}` },
        react_1.default.createElement("p", { className: "mb-[16px] typography-h200" }, title),
        listNavigatorContents.map((content) => {
            return (react_1.default.createElement("div", { id: useId ? `nav-${content.id}` : '', key: content.id, className: `content ${activeSection === content.id ? 'active' : ''}`, onClick: () => scrollToElement(content.id), "data-cy": `content-${content.id}` }, (0, HelperUtils_1.getObjectiveLocale)(content.name)));
        })));
};
exports.default = ContentNavigator;
